import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import AuthVerifyScreen from './AuthVerifyScreen';
import { currentAdmin } from '../functions/auth';

// ฟังก์ชันตรวจสอบ token หมดอายุ
const isTokenExpired = (token) => {
    if (!token || typeof token !== 'string') return true;
    try {
        const part = token.split('.')[1];
        if (!part) return true;
        const base64 = part.replace(/-/g, '+').replace(/_/g, '/');
        const json = decodeURIComponent(
            atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
        );
        const payload = JSON.parse(json);
        const exp = Number(payload?.exp);
        if (!exp || isNaN(exp)) return true;
        // ให้เวลา buffer 30 วินาที
        return exp < (Math.floor(Date.now() / 1000) - 30);
    } catch (error) {
        console.warn('Token validation error:', error);
        return true;
    }
};

const AdminRoute = ({ children }) => {
    const user = useSelector(state => state.user);
    const dispatch = useDispatch();
    const location = useLocation();

    const [ok, setOk] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;

        const verifyAdmin = async () => {
            setLoading(true);
            setOk(false);

            const token = localStorage.getItem('token');

            // ตรวจสอบ token ใน localStorage ก่อน
            if (!token || isTokenExpired(token)) {
                if (token) localStorage.removeItem('token');
                dispatch({ type: 'LOGOUT', payload: null });
                if (isMounted) {
                    setOk(false);
                    setLoading(false);
                }
                return;
            }

            // ถ้ามี user ใน state และมี token ตรงกัน -> verify กับ server
            if (user && user.token === token) {
                try {
                    await currentAdmin(token);
                    if (isMounted) {
                        setOk(true);
                        setLoading(false);
                    }
                } catch (error) {
                    console.error('Admin verification failed:', error);
                    localStorage.removeItem('token');
                    dispatch({ type: 'LOGOUT', payload: null });
                    if (isMounted) {
                        setOk(false);
                        setLoading(false);
                    }
                }
            } else {
                // ไม่มี user ใน state หรือ token ไม่ตรงกัน
                if (isMounted) {
                    setOk(false);
                    setLoading(false);
                }
            }
        };

        verifyAdmin();

        return () => { isMounted = false; };
    }, [user, location.pathname, dispatch]);

    // ระหว่างการตรวจสอบ แสดง AuthVerifyScreen card เดียว
    if (loading) {
        return <AuthVerifyScreen />;
    }

    // ผ่าน -> แสดง children / ไม่ผ่าน -> redirect
    return ok ? children : <Navigate to="/login" replace />;
};

export default AdminRoute;
